import React, { useState } from 'react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };
    return (
        <header className="bg-black shadow-lg py-4 fixed w-full z-50 rounded-b-xl border-b border-gray-800">
            <div className="container mx-auto flex justify-between items-center px-4 md:px-8">
                {/* Logo */}
                <a href="#home" className="flex items-center space-x-2 md:space-x-4">
                    <img 
                        src="/images/Logo.jpeg" 
                        alt="Kalabandhan Logo" 
                        className="h-12 md:h-16 rounded-md"
                    />
                    <span className="text-2xl md:text-4xl font-extrabold bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 text-transparent bg-clip-text tracking-wide" style={{ fontFamily: 'Samarkan' }}>
                        Kalabandhan
                    </span>
                </a>

                {/* Desktop Navigation */}
                <nav className="hidden md:flex space-x-8">
                    <a href="#home" className="text-gray-300 hover:text-purple-400 font-medium transition duration-300 ease-in-out">
                        Home
                    </a>
                    <a href="#bharatanatyam" className="text-gray-300 hover:text-purple-400 font-medium transition duration-300 ease-in-out">
                        Bharatanatyam
                    </a>
                    <a href="#carnatic-music" className="text-gray-300 hover:text-purple-400 font-medium transition duration-300 ease-in-out">
                        Carnatic Music
                    </a>
                    <a href="#other-arts" className="text-gray-300 hover:text-purple-400 font-medium transition duration-300 ease-in-out">
                        Other Arts
                    </a>
                    <a href="#gallery" className="text-gray-300 hover:text-purple-400 font-medium transition duration-300 ease-in-out">
                        Gallery
                    </a>
                </nav>

                {/* Mobile Menu Button */}
                <button 
                    id="mobile-menu-button"
                    className="md:hidden text-gray-300 focus:outline-none"
                    aria-label="Toggle mobile menu"
                    onClick={toggleMenu}
                >
                    <i className="fas fa-bars text-2xl"></i>
                </button>
            </div>

            {/* Mobile Menu */}
            <div 
                id="mobile-menu"
                className={`${isMenuOpen ? 'flex' : 'hidden'} md:hidden fixed inset-0 bg-black bg-opacity-95 z-40 flex-col items-center justify-center space-y-6`}
            >
                <button 
                    id="close-mobile-menu"
                    className="absolute top-6 right-6 text-gray-300 focus:outline-none"
                    aria-label="Close mobile menu"
                    onClick={closeMenu}
                >
                    <i className="fas fa-times text-3xl"></i>
                </button>
                <a href="#home" className="text-gray-300 text-2xl font-semibold hover:text-purple-400 transition duration-300 ease-in-out py-2" onClick={closeMenu}>
                    Home
                </a>
                <a href="#bharatanatyam" className="text-gray-300 text-2xl font-semibold hover:text-purple-400 transition duration-300 ease-in-out py-2" onClick={closeMenu}>
                    Bharatanatyam
                </a>
                <a href="#carnatic-music" className="text-gray-300 text-2xl font-semibold hover:text-purple-400 transition duration-300 ease-in-out py-2" onClick={closeMenu}>
                    Carnatic Music
                </a>
                <a href="#other-arts" className="text-gray-300 text-2xl font-semibold hover:text-purple-400 transition duration-300 ease-in-out py-2" onClick={closeMenu}>
                    Other Arts
                </a>
                <a href="#gallery" className="text-gray-300 text-2xl font-semibold hover:text-purple-400 transition duration-300 ease-in-out py-2" onClick={closeMenu}>
                    Gallery
                </a>
            </div>
        </header>
    );
};

export default Header;
